const LABELED_ATTR = 'data-mobile-labeled';

function labelMobileCardTables(root = document) {
  const tables = root.querySelectorAll('.mobile-card-table');

  tables.forEach((table) => {
    const headers = Array.from(table.querySelectorAll('thead th')).map((th) => (
      th.textContent || ''
    ).replace(/\s+/g, ' ').trim());

    table.querySelectorAll('tbody tr').forEach((row) => {
      const cells = Array.from(row.children).filter((node) => node.tagName === 'TD');
      cells.forEach((cell, index) => {
        const label = headers[index] || '';
        if (label) {
          cell.setAttribute('data-label', label);
        } else {
          cell.removeAttribute('data-label');
        }
      });
      row.setAttribute(LABELED_ATTR, 'true');
    });
  });
}

export function installMobileCardTableLabels(app) {
  if (typeof window === 'undefined') {
    return;
  }

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      labelMobileCardTables(document);
    });
  };

  app.mixin({
    mounted() {
      schedule();
    },
    updated() {
      schedule();
    },
  });

  window.addEventListener('resize', schedule);
}
